<template>
  <div class="chat-room">
    <div class="left">
      <div class="title">会话记录({{ navItems.length }})</div>
      <ul>
        <li v-for="(item, index) in navItems" :key="index" @contextmenu.prevent="showDeleteButton(index, $event)"
          :class="{ 'show-delete': deleteIndex === index }" id="liiiii" ref="listItems"
          @click="selectNavItem(item, index)">
          <div class="aaa">
            <span v-if="item.adminUnreadMessageCount > 0" class="number">{{ item.adminUnreadMessageCount }}</span>
            <img :src=item.userAvatar alt="">
            <div class="center1">
              <p class="title">{{ item.userNickname }}</p>
              <p class="content">{{ item.text }}</p>
            </div>
            <div class="time">{{ parseTime(item.lastMessageTime) }}</div>
          </div>

          <el-button type="info" class="deletes" v-if="deleteIndex === index"
            @click="deleteItem(item, index)">删除</el-button>
        </li>
      </ul>
    </div>
    <div class="right" v-if="activeId">
      <el-container>
        <el-header>
          <h2>{{ name }}</h2>
        </el-header>
        <el-main>
          <div class="chat-window">
            <div class="chat-messages">
              <!-- 聊天消息列表 -->
              <div v-for="(message, index) in messages" :key="index">
                <div class="chat-message" v-if="message.senderId == userId">
                  <div class="avatar">
                    <img v-if="senderAvatar != ''" :src="senderAvatar" alt="用户头像">
                  </div>
                  <div class="message-content">
                    <!-- <span class="username">{{ message.username }}</span> -->
                    <p>{{ message.text }}</p>
                    <!-- <span class="timestamp">{{ message.timestamp }}</span> -->
                  </div>
                </div>

                <div v-else class="chat-messagea">
                  <div class="message-content">
                    <!-- <span class="username">{{ message.username }}</span> -->
                    <p>{{ message.text }}</p>
                    <!-- <span class="timestamp">{{ message.timestamp }}</span> -->
                  </div>
                  <div class="avatar">
                    <img :src="userInfo.avatar" alt="用户头像">
                  </div>
                </div>
              </div>
            </div>
            <div class="input-area">
              <el-input type="textarea" v-model="inputMessage" placeholder="输入消息,Enter发送"
                @keyup.enter.native="sendMessages"></el-input>
              <!-- <el-button type="primary" @click="sendMessages">发送</el-button> -->
            </div>
          </div>
        </el-main>
      </el-container>
    </div>

  </div>
</template>

<script>
import { Message } from 'element-ui';

export default {
  data() {
    return {
      inputMessage: '',
      navItems: [],
      selectedIndex: null,
      messages: [],
      activeId: '',
      senderId: '',
      senderAvatar: '',
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      name: '',
      userId: '',
      ws: '',
      deleteIndex: null,
    };
  },
  created() {
    this.load()
    this.connectWebSocket();
  },
  mounted() {

  },
  methods: {
    showDeleteButton(index, event) {
      this.deleteIndex = index;
      event.preventDefault();
      this.$nextTick(() => { // 确保 DOM 更新完成
        const deleteButton = this.$refs.listItems[index].querySelector('button');
        const rect = this.$refs.listItems[index].getBoundingClientRect();
        deleteButton.style.left = `${event.clientX - rect.left}px`;
        deleteButton.style.top = `${event.clientY - rect.top + 20}px`; // 调整位置使其显示在 li 元素上方
        deleteButton.style.display = 'block';
      });
    },

    // 删除会话
    deleteItem(item, index) {
      this.deleteIndex = null;
      this.request.delete('https://npsap.com/app-api/promotion/pc-message/delete', {
        params: {
          id: item.id,
        }
      }).then(res => {
        if (res.code == 0) {
          this.messages = res.data
          if (this.activeId == item.id) {
            this.activeId = ''
          }
          this.load()
        }
      })
    },
    selectNavItem(item, index) {
      if (this.deleteIndex === index) {
        this.deleteIndex = null;
      }
      this.activeId = item.id
      this.senderAvatar = item.userAvatar

      this.name = item.userNickname
      this.userId = item.userId
      item.adminUnreadMessageCount = 0
      this.request.put('https://npsap.com/app-api/promotion/pc-message/update-read-status?conversationId=' + item.id).then(res => {
      })
      this.selectedIndex = index;
      this.dange()
    },
    dange() {
      this.request.get('https://npsap.com/app-api/promotion/pc-message/list?conversationId=' + this.activeId).then(res => {
        if (res.code == 0) {
          this.messages = res.data
          // this.senderId = res.data[0].senderId
          this.messages.map(item => {
            let content = JSON.parse(item.content)
            if (content.text) {
              item.text = content.text
            } else {
              item.picUrl = content.picUrl
            }
          })

          this.messages.reverse();
        }
      })
    },
    load() {
      this.request.get('https://npsap.com/app-api/promotion/pc-message/allList').then(res => {
        this.navItems = res.data
        this.navItems.map(item => {
          item.text = JSON.parse(item.lastMessageContent).text
        })
      })
    },
    sendMessages() {
      if (this.inputMessage.trim()) {
        let aaa = {
          text: this.inputMessage
        }
        let data = {
          contentType: 1,
          content: JSON.stringify(aaa),
          receiverId: this.userId
        }

        this.request.post('https://npsap.com/app-api/promotion/pc-message/send', data).then(res => {
          if (res.code == 0) {
            this.inputMessage = ''
            this.dange()
          } else {
            this.$message.error(res.msg)
          }

        })

      }
    },
    connectWebSocket() {
      let token = JSON.parse(localStorage.getItem("user")).accessToken
      // 假设你的WebSocket服务地址是ws://your-websocket-server
      this.webSocket = new WebSocket('wss://npsap.com/infra/ws?token=' + token);

      this.webSocket.onopen = () => {
        console.log('WebSocket connected');
      };

      this.webSocket.onmessage = (message) => {
        const data = JSON.parse(message.data);
        console.log('接受数据', data);

        // 假设接收到的数据是一个JSON对象，包含了type字段
        if (data.type == 'pc_message_type') {
          // 调用接口的方法
          this.load();
          if (this.activeId) {
            this.dange()
          }
        }
      };

      this.webSocket.onerror = (error) => {
        console.error('WebSocket error:', error);
      };

      this.webSocket.onclose = () => {
        console.log('WebSocket disconnected');
      };
    },
  },
  beforeDestroy() {
    if (this.webSocket) {
      this.webSocket.close();
    }
  },
};
</script>

<style scoped lang="scss">
.chat-room {
  height: 100vh;
  display: flex;
  /* flex-direction: column; */

  .left {
    width: 320px;
    height: 100%;
    background-color: #e5e4e4;

    #liiiii {
      position: relative;
    }

    .deletes {
      display: none;
      position: absolute;
      left: 215px !important;
      top: 15px !important;
      width: 60px;
    }

    .title {
      margin: 15px 0 10px 0;
    }

    .aaa {
      display: flex;
      height: 40px;
      position: relative;

      .number {
        position: absolute;
        width: 15px;
        height: 15px;
        border-radius: 50%;
        line-height: 15px;
        text-align: center;
        left: 30px;
        top: -9px;
        background-color: red;
        color: #fff;
      }

      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 8px;
      }

      .center1 {
        width: 95px;
        margin-right: 15px;

        .content {
          width: 95px;
          white-space: nowrap;
          /* 不换行 */
          overflow: hidden;
          /* 超出部分隐藏 */
          text-overflow: ellipsis;
          /* 使用省略符号 */
        }

      }

      p {
        margin: 0;
        padding: 0;
      }

      .content {
        font-size: 10px;
      }
    }

    .time {
      font-size: 10px;
      line-height: 50px;
    }
  }

  .right {
    width: calc(100% - 280px);
    background-color: #f5f5f5;
  }
}

.chat-window {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
  background-color: #f5f5f5;
}

.chat-messages {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.chat-message {
  display: flex;
  align-items: center;
}

.chat-messagea {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .avatar {
    margin-left: 10px;
  }
}

.avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 10px;

  img {
    border-radius: 50%;
    width: 30px;
    height: 30px;
  }
}

.message-content {
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  max-width: 70%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.username {
  font-weight: bold;
  color: #333;
}

.timestamp {
  font-size: 12px;
  color: #999;
}

.input-area {
  display: flex;
  gap: 10px;
  padding: 10px;
  /* background-color: #fff; */
  border-top: 1px solid #ddd;
  margin-top: 30px;
  position: fixed;
  width: calc(100% - 320px);
  bottom: 30px;
  left: 320px;

  .el-textarea__inner {
    background-color: #f5f5f5;
    border: none;
  }
}

ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

li {
  padding: 10px;
  cursor: pointer;
}

li.active {
  background-color: #b2b2b2;
  color: #000;
}

.content {
  color: #999;
}
</style>